const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import request from "Sources/services/request";
import AppError from "Sources/models/app-error";

let GameSessionServices = {};

(GameSessionServices => {
  GameSessionServices.getGameSessions = function () {
    return request.get({
      url: utils.getServiceUrl("/game-sessions"),
      cache: false,
      dataType: request.DATA_TYPES.JSON
    })
      .then(data => {
        if (data.result === "success") {
          return data.data;
        } else {
          throw new AppError({
            code: null,
            message: null,
            data,
            exception: new Error("Unexpected result from request")
          });
        }
      });
  };

  GameSessionServices.createGameSession = function (gameSession) {
    return request.post({
      url: utils.getServiceUrl("/game-sessions"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: gameSession
    });
  };

  GameSessionServices.removeGameSession = function (gameSessionId) {
    return request.delete({
      url: utils.getServiceUrl(`/game-sessions/${gameSessionId}?for-sessionid=true`),
      cache: false,
      dataType: request.DATA_TYPES.JSON
    });
  };

  GameSessionServices.duplicateGameSession = function (gameSessionId) {
    return request.post({
      url: utils.getServiceUrl(`/game-sessions/${gameSessionId}/duplicate?for-sessionid=true`),
      cache: false,
      dataType: request.DATA_TYPES.JSON
    });
  };

  GameSessionServices.removeTeamFromGameSession = function (teamName, gameSessionId) {
    return request.post({
      url: utils.getServiceUrl(`/game-sessions/${gameSessionId}/remove-team?for-sessionid=true`),
      cache: false,
      data: {
        "team-name": teamName
      }
    });
  };

  GameSessionServices.goToSession = function (gameSessionId) {
    utils.redirect(`/teacher/sessions/${gameSessionId}`);
  };
})(GameSessionServices);

export default GameSessionServices;



// WEBPACK FOOTER //
// ./app/js/services/gamesession-services.js